import React, { useState } from 'react';
import {
  Clear,
} from "@mui/icons-material";
import { Popover } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  Character, 
  CharacterAbility, 
  CharacterFeatureSource, 
  CharacterSheetInterface, 
  RolledValue, 
  RollPlus
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import ViewSpell from "@dndComponents/display/ViewSpell";
import Roller from "@dndComponents/other/Roller";

interface Props {
  character: Character; 
  char_interface: CharacterSheetInterface;
  disabled: boolean;
  shared: boolean;
  onChange: () => void;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function ConcentrationInput({ 
  character,
  char_interface,
  disabled,
  shared,
  onChange,
}: Props) {
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLDivElement | null>(null);
  const [roll, setRoll] = useState<RolledValue[]>([]);

  const renderExtras = () => {
    return (
      <Popover key="rolls"
        open={ popoverAnchorEl !== null }
        anchorEl={popoverAnchorEl}
        onClose={() => {
          setPopoverAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        { popoverAnchorEl !== null && renderRoll() }
      </Popover>
    );
  }

  const renderRoll = () => {
    // const { advantage } = char_util.getAdvantage(char_interface, "Saving Throw", "CON");
    // const rolls: RollPlus[] = [];
    // const roll_plus = new RollPlus();
    // roll_plus.ability_score = "CON";
    // if (char_interface.proficiencies.filter(o => o.type === "Saving Throw" && o.proficiency_id === "CON").length > 0) {
    //   roll_plus.flat = +character.proficiency_modifier;
    // }
    // rolls.push(roll_plus);
    // char_interface.saving_throw_bonuses.forEach(bonus => {
    //   if (bonus.types.length === 0 || bonus.types.includes("CON")) {
    //     rolls.push(char_util.toRollPlus(bonus.rolls, { obj: char_interface }));
    //   }
    // });
    // const minimum_roll = char_util.getMinimumRoll(char_interface, "Saving Throw", "CON");
    return (
      <Roller 
        name={"Concentration Check"}
        // char={character}
        // char_interface={char_interface}
        rolled_values={roll}
        type="Saving Throw" 
      />
    );
  }

  if (character.concentrating_on) {
    // debugger;
    let cfs: CharacterFeatureSource | null = null;
    if (character.concentrating_on instanceof CharacterAbility) {
      const source_true_id = character.concentrating_on.source_true_id;
      const item_id = character.concentrating_on.item_id;
      const cfs_finder = character.all_char_feature_sources.filter(o => o.true_id === source_true_id || o.true_id === item_id);
      if (cfs_finder.length > 0) {
        cfs = cfs_finder[0];
      }
    }
    return (
      <span style={{ 
          borderRight: "1px solid",
          margin: "4px",
          width: "200px"
        }}>
        <span className="clickable" onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            const { advantage, greater_advantage } = char_util.getAdvantage(char_interface, "Saving Throw", "CON");
            const rolls: RollPlus[] = [];
            const roll_plus = new RollPlus();
            roll_plus.ability_score = "CON";
            if (char_interface.proficiencies.filter(o => o.type === "Saving Throw" && o.proficiency_id === "CON").length > 0) {
              roll_plus.flat = +character.proficiency_modifier;
            }
            rolls.push(roll_plus);
            char_interface.saving_throw_bonuses.forEach(bonus => {
              if (bonus.types.length === 0 || bonus.types.includes("CON")) {
                rolls.push(char_util.toRollPlus(bonus.rolls, { obj: char_interface }));
              }
            });
            const minimum_roll = char_util.getMinimumRoll(char_interface, "Saving Throw", "CON");
            // const greater_advantage = character.greater_advantages.filter(o => (o.roll_types.length === 0 || o.roll_types.includes("Saving Throw")) && (o.use_ability_scores.length === 0 || o.use_ability_scores.includes("CON"))).length > 0;
            setRoll(char_util.rollD20({ char_interface, rolls, type: "Saving Throw", use_ability_score: "CON", advantage, greater_advantage, minimum_roll }));
            setPopoverAnchorEl(event.currentTarget);
          }}>Concentrating on</span>
        <Grid container spacing={0} direction="row">
          <Grid
            className="clickable"
            onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                const { advantage, greater_advantage } = char_util.getAdvantage(char_interface, "Saving Throw", "CON");
                const rolls: RollPlus[] = [];
                const roll_plus = new RollPlus();
                roll_plus.ability_score = "CON";
                if (char_interface.proficiencies.filter(o => o.type === "Saving Throw" && o.proficiency_id === "CON").length > 0) {
                  roll_plus.flat = +character.proficiency_modifier;
                }
                rolls.push(roll_plus);
                char_interface.saving_throw_bonuses.forEach(bonus => {
                  if (bonus.types.length === 0 || bonus.types.includes("CON")) {
                    rolls.push(char_util.toRollPlus(bonus.rolls, { obj: char_interface }));
                  }
                });
                const minimum_roll = char_util.getMinimumRoll(char_interface, "Saving Throw", "CON");
                // const greater_advantage = character.greater_advantages.filter(o => (o.roll_types.length === 0 || o.roll_types.includes("Ability Check")) && (o.use_ability_scores.length === 0 || o.use_ability_scores.includes("CON"))).length > 0;
                setRoll(char_util.rollD20({ char_interface, rolls, type: "Saving Throw", use_ability_score: "CON", advantage, greater_advantage, minimum_roll }));
                setPopoverAnchorEl(event.currentTarget);
              }}
            size={{
              xs: 9
            }}>
            <ViewSpell spell={character.concentrating_on} cfs={cfs} show_ritual />
          </Grid>
          <Grid
            size={{
              xs: 3
            }}>
            { !disabled && 
              <Clear style={{ cursor: "pointer" }} 
                onClick={() => {
                  character.concentrating_on = null;
                  onChange();
                }} 
              />
            }
          </Grid>
        </Grid>
        { renderExtras() }
      </span>
    );
  }
  return <></>;
}
